module.exports = __webpack_public_path__ + "/images/logo-af-walmart.d244de9.svg";